import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormItem, FormOption, TabItem } from './FormItem';
import { BehaviorSubject, of } from 'rxjs';
import { startWith, pairwise } from 'rxjs/operators';
import { FieldTypes } from '../../FieldTypes';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
  selector: 'vias-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit, OnChanges {
  @Input() numLocale: string;
  @Input() formItems: FormItem[] = [];
  @Input() tabs: TabItem[] = [];
  @Input() tabSelectedIndex: number = 0;
  @Input() tabFunc: () => void;
  @Input() hasSubmitBtn: boolean = false;
  submitBtnItem: FormItem;
  @Input() submitBtnText: string = '';
  @Output() tabSelectedIndexChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() formChange: EventEmitter<object> = new EventEmitter<object>();
  @Output() formItemClick: EventEmitter<FormItem> = new EventEmitter<FormItem>();
  form: FormGroup;

  tabArr: TabItem[];
  constructor(private fb: FormBuilder) { }

  @ViewChild(MatTabGroup, { static: false }) tabGroup: MatTabGroup;
  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.form = this.createControl();
    // const formItem = this.formItems[0];
    // let x =
    if (this.hasSubmitBtn) {
      this.submitBtnItem = {
        type: FieldTypes.Submit,
        name: 'frmSubmitBtn',
        label: this.submitBtnText
      };
    }
    this.tabArr = [];
    this.tabs.forEach(t => {
      if (t.icon === undefined) {
        t.icon = '';
      }
      if (t.disabled === undefined) {
        t.disabled = false;
      }
      this.tabArr.push(t);
    });
    if (this.tabSelectedIndex !== undefined) {
      console.log('+___+ move to ' + this.tabSelectedIndex);
      this.moveToTab(this.tabSelectedIndex);
    }

    // console.log(changes);

    // // eger formitems icinde degisiklik oldu ise
    // if (changes['formItems'] !== undefined){
    //   // ilk set ettigi degisiklik degil ise
    //   if (!changes['formItems'].firstChange ){
    //     // tabloyu (yani dg) tekrar cizmesi lazim
    //     changes['formItems'].currentValue.forEach( item => {
    //       if (item.type === FieldTypes.Table){
    //        if(this.form.controls[item.name] !== undefined){
    //          console.log(this.form.controls[item.name]);
    //          this.form.controls[item.name].setValue(item, {onlySelf: true});
    //        }
    //       }
    //     });
    //   }
    // }



    this.onChanges();
  }

  get value(): any {
    return this.form.value;
  }

  // ngDoCheck(): void{
  //   console.log('onur');
  // }

  onChanges(): void {
    this.form.valueChanges
      // tslint:disable-next-line:deprecation
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        // tslint:disable-next-line: forin
        for (const itemName in next) {
          let emit = false;
          // eskiden null ise
          if (prev === null) {
            // yeni deger var ise
            if (next[itemName] !== null) {
              emit = true;
            }
            // eskiden varsa degismisse !!!
          } else if (prev.hasOwnProperty(itemName)) {
            // degerleri degismis ise gonder
            // ilk degisiklik buldugunu gonderecek
            if (prev[itemName] !== next[itemName]) {
              emit = true;
            }
            // eskiden yoksa, ilk degisiklik direk gonder
          } else {
            emit = true;
          }
          if (emit) {
            const fi = this.formItems.find(fix => fix.name === itemName);
            if (fi.type === FieldTypes.DatePicker){
              if(next[itemName] !== undefined && next[itemName] !== null){
                if (next[itemName]._d !== undefined){
                  next[itemName] = next[itemName]._d;
                }
              }
            }
            this.formChange.emit({ itemName, val: next[itemName] });
            return;
          }
        }
      });
  }

  createControl(): FormGroup {
    const group = this.fb.group({});

    // form item icin islemler yap
    this.formItems.forEach(item => {
      // eger db den gelen data source iceride options a yazilacak ise
      if (item.optionsDataSource !== undefined) {

        // tablo var ise diye tablo datasini da doldur.
        if (item.tableColumns !== undefined) {
          item.tableDataSource = item.optionsDataSource;
        } else {
          item.options = [];
          // id ve label alanlarini duzelt
          item.optionsDataSource.forEach(e => {
            const opt: FormOption = { data: '-1', label: '' };
            if (item.optionsDataIdField !== undefined) {
              opt.data = e[item.optionsDataIdField];
            } else {
              opt.data = e['data'];
            }
            if (item.optionsDataLabelField !== undefined) {
              opt.label = e[item.optionsDataLabelField];
            } else {
              opt.label = e['label'];
            }
            item.options.push(opt);
          });
        }

      }

      if (item.tableChange === undefined) {
        item.tableChange = ($event): void => {
          this.formChange.emit({ itemName: item.name, val: $event });
        };
      }

      // bu item icin validationlari calistir
      const control = this.fb.control(
        {
          value: item.value,
          disabled: item.disabled
        },
        this.bindValidations(item.validations || [])
      );
      // bu item i formcontrol icine ekle
      group.addControl(item.name, control);

    });
    return group;
  }

  bindValidations(validations: any): any {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach(valid => {
        validList.push(valid.validator);
      });
      return Validators.compose(validList);
    }
    return null;
  }

  onSubmit(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.form.valid) {
      this.formSubmit.emit(this.form.value);
    } else {
      this.validateAllFormFields(this.form);
    }
  }

  onFormItemClick(event: FormItem): void {
    this.formItemClick.emit(event);
  }
  onTabSelectedIndexChange(index: number): void {
    this.tabSelectedIndexChange.emit(index);
  }

  validateAllFormFields(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  moveToNext(isNext: boolean = true): void {
    if (!this.tabGroup || !(this.tabGroup instanceof MatTabGroup)) { return; }
    if (isNext) {
      this.moveToTab(this.tabGroup.selectedIndex + 1);
    } else {
      this.moveToTab(this.tabGroup.selectedIndex - 1);
    }
  }
  moveToTab(tabIndex: number = 0): void {
    if (!this.tabGroup || !(this.tabGroup instanceof MatTabGroup)) { return; }
    const tabCount = this.tabGroup._tabs.length;
    if (tabIndex > tabCount - 1) {
      tabIndex = tabCount - 1;
    } else if (tabIndex < 0) {
      tabIndex = 0;
    }
    this.tabGroup.selectedIndex = tabIndex;
    //      this.tabGroup.selectedIndex = (this.tabGroup.selectedIndex + 1) % tabCount;
  }
}
